var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"card-center"},[_c('div',{staticClass:"card"},[_c('h3',[_vm._v("Sistema de Gestão Administrativa "+_vm._s(_vm.isHeaven ? 'Heaven' : 'Greenn')+", Seja muito bem vindo(a)!")])])]),_c('img',{staticClass:"imgDecor",attrs:{"src":require("../../assets/home.svg"),"alt":"img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }